//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Carousel, Slide } from '@fc/angie-ui';
import FCImage from '~/components/FCImage.vue';

export default {
  name: 'OriginStoryMobileView',
  components: {
    Carousel,
    Slide,
    FCImage,
  },
  props: {
    originStoryList: {
      type: Array,
      required: true,
      validator(data) {
        return data.every(entry => entry.src && entry.alt && entry.title && entry.text);
      },
    },
  },
  computed: {
    isReverseOrder() {
      return (index) => (index ? 'origin-story__text-reverse-order' : '');
    },
    getHeaderMargin() {
      return (index) => (index ? 'origin-story__header-at-bottom' : 'origin-story__header-at-top');
    },
  },
};
